import React from 'react';
import { Tag, TagType } from '@juno/client-api/model';
import { FilterSidePanel, MentorshipFilter, MentorshipStatusFilter, TagsFilter } from '@juno/ui';
import { useDirectoryData } from '../Contexts/DirectoryContext';
import { useDirectoryFilters } from '../Contexts/DirectoryFiltersContext';

interface DirectoryFiltersProps {
  tagsFiltersApplied: Tag[];
  mentorshipFiltersApplied: MentorshipFilter[];
  isLoadingTagTypes: boolean;
  isLoadingTags: boolean;
  tags: Tag[];
  tagTypes: TagType[];
}

const DirectoryFilters: React.FC<DirectoryFiltersProps> = ({
  tagsFiltersApplied,
  mentorshipFiltersApplied,
  isLoadingTagTypes,
  isLoadingTags,
  tags,
  tagTypes,
}) => {
  const { showMentorshipFilter, showTagsFilter } = useDirectoryData();
  const {
    appendTagFilter,
    removeTagFilter,
    appendMentorshipFilter,
    removeMentorshipFilter,
    resetPage,
  } = useDirectoryFilters();

  return (
    <FilterSidePanel>
      {showMentorshipFilter && (
        <MentorshipStatusFilter
          selectedFilters={mentorshipFiltersApplied}
          appendFilter={(filter) => {
            resetPage();
            appendMentorshipFilter(filter.value);
          }}
          removeFilter={(filter) => {
            resetPage();
            removeMentorshipFilter(filter.value);
          }}
          totalFiltersApplied={tagsFiltersApplied.length + mentorshipFiltersApplied.length}
        />
      )}
      {showTagsFilter && (
        <TagsFilter
          tags={tags || []}
          tagTypes={tagTypes || []}
          selectedFilters={tagsFiltersApplied}
          appendFilter={(filter) => {
            resetPage();
            appendTagFilter(filter);
          }}
          removeFilter={(filter) => {
            resetPage();
            removeTagFilter(filter);
          }}
          isLoadingTagTypes={isLoadingTagTypes}
          isLoadingTags={isLoadingTags}
          totalFilterApplied={tagsFiltersApplied.length + mentorshipFiltersApplied.length}
        />
      )}
    </FilterSidePanel>
  );
};

export default DirectoryFilters;
